/* 47X · COMPONENTES CRO COMPARTIDOS · ES5
   ─────────────────────────────────────────────────────────────────────────
   Un solo archivo para los cinco componentes. Cada uno se monta únicamente
   si su marcado está en la página, así que llevarlo a una landing nueva no
   cuesta código nuevo: se renderiza el snippet y ya.

   Nada corre por frame. Todo lo que observa usa IntersectionObserver.
*/
(function () {
  'use strict';

  /* Varios componentes piden esta hoja; el navegador la descarga una vez pero
     la ejecutaría tantas veces como etiquetas haya. Este candado lo evita. */
  if (window.__cro47) return;
  window.__cro47 = 1;

  function ev(nombre, datos) {
    try { if (window.Ev47) window.Ev47.pub(nombre, datos || {}); } catch (e) {}
  }
  function evUna(nombre, datos) {
    try { if (window.Ev47) window.Ev47.unaVez(nombre, datos || {}); } catch (e) {}
  }

  /* ── PRUEBA SOCIAL · números REALES del Worker ───────────────────────
     Si el Worker no responde o no hay reseñas, el bloque se repliega. Nunca
     se pinta un rating inventado ni un conteo de relleno. */
  function montaSocial() {
    var cajas = document.querySelectorAll('[data-cro47-social]');
    if (!cajas.length || !window.__RV47) return;

    window.__RV47.cargar().then(function (todas) {
      if (!todas || !todas.length) {
        for (var z = 0; z < cajas.length; z++) cajas[z].hidden = true;
        return;
      }
      var suma = 0, n = 0, fotos = [];
      for (var i = 0; i < todas.length; i++) {
        var r = todas[i];
        var cal = parseInt(r.rating, 10);
        if (cal >= 1 && cal <= 5) { suma += cal; n++; }
        if (fotos.length < 3 && r.photos && r.photos.length) {
          for (var f = 0; f < r.photos.length && fotos.length < 3; f++) {
            if (window.__RV47.fotoOk(r.photos[f])) fotos.push(r.photos[f]);
          }
        }
      }
      if (!n) { for (var y = 0; y < cajas.length; y++) cajas[y].hidden = true; return; }

      var prom = Math.round(suma / n * 10) / 10;
      var estrellas = window.__RV47.estrellas(Math.round(prom));

      for (var c = 0; c < cajas.length; c++) {
        var caja = cajas[c];
        var e1 = caja.querySelector('[data-cro47-est]');
        var e2 = caja.querySelector('[data-cro47-prom]');
        var e3 = caja.querySelector('[data-cro47-conteo]');
        var e4 = caja.querySelector('[data-cro47-fotos]');
        if (e1) e1.textContent = estrellas;
        if (e2) e2.textContent = prom.toFixed(1);
        if (e3) e3.textContent = n + (n === 1 ? ' reseña verificada' : ' reseñas verificadas');
        if (e4) {
          if (!fotos.length) { e4.hidden = true; }
          else {
            var html = '';
            for (var k = 0; k < fotos.length; k++) {
              html += '<img src="' + window.__RV47.esc(fotos[k]) + '" alt="Foto de una compra real" loading="lazy" decoding="async" width="38" height="38">';
            }
            e4.innerHTML = html; e4.hidden = false;
          }
        }
        caja.hidden = false;
      }
    }).catch(function () {});
  }

  /* ── GUÍA RÁPIDA DE TALLAS ──────────────────────────────────────────── */
  function montaTallas() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('[data-cro47-gt-abrir]') : null;
      if (!btn) return;
      e.preventDefault();
      var caja = document.querySelector('#' + btn.getAttribute('aria-controls'));
      if (!caja) return;
      var abierta = !caja.hidden;
      caja.hidden = abierta;
      btn.setAttribute('aria-expanded', abierta ? 'false' : 'true');
      if (!abierta) {
        ev('size_guide_opened', { pagina: location.pathname });
        caja.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }, false);
  }

  /* ── STICKY ADD TO CART ─────────────────────────────────────────────────
     No agrega nada por su cuenta: refleja el botón real de la página y le
     reenvía el clic. Así es imposible que agregue un producto equivocado o
     que se salte una selección obligatoria. */
  function montaSticky() {
    var barra = document.querySelector('[data-cro47-sticky]');
    if (!barra) return;
    var sel = barra.getAttribute('data-cro47-destino');
    var real = sel ? document.querySelector(sel) : null;
    if (!real) { barra.remove(); return; }

    var boton = barra.querySelector('[data-cro47-sticky-b]');

    function espeja() {
      if (!boton) return;
      var bloqueado = real.disabled === true || real.getAttribute('aria-disabled') === 'true';
      boton.classList.toggle('is-falta', bloqueado);
      var txt = (real.textContent || '').replace(/\s+/g, ' ').trim();
      if (txt) boton.textContent = txt.length > 34 ? txt.slice(0, 32) + '…' : txt;
    }

    if (boton) {
      boton.addEventListener('click', function (e) {
        e.preventDefault();
        ev('sticky_atc_clicked', { pagina: location.pathname });
        real.click();                         /* el botón real manda, siempre */
      });
    }

    espeja();
    if ('MutationObserver' in window) {
      var mo = new MutationObserver(espeja);
      mo.observe(real, { attributes: true, childList: true, subtree: true,
                         attributeFilter: ['disabled', 'aria-disabled', 'class'] });
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) {
        for (var i = 0; i < en.length; i++) {
          var e = en[i];
          /* OJO con la dirección: solo cuando el botón real quedó ARRIBA, o
             sea que el cliente ya pasó de largo. Con `!isIntersecting` a secas
             la barra también salía al principio, antes de que la persona
             llegara siquiera a ver la oferta — justo la distracción que
             queremos quitar, no agregar. */
          var yaPaso = !e.isIntersecting && e.boundingClientRect.top < 0;
          barra.classList.toggle('is-on', yaPaso);
        }
      }, { rootMargin: '0px 0px -12% 0px' });
      io.observe(real);
    }
  }

  /* ── vistas, una sola vez ───────────────────────────────────────────── */
  function montaVistas() {
    if (!('IntersectionObserver' in window)) return;
    var inc = document.querySelector('[data-cro47-incluye]');
    if (!inc) return;
    var io = new IntersectionObserver(function (en) {
      for (var i = 0; i < en.length; i++) {
        if (en[i].isIntersecting) { evUna('includes_viewed', { pagina: location.pathname }); io.disconnect(); }
      }
    }, { threshold: 0.35 });
    io.observe(inc);
  }

  function arranca() { montaSocial(); montaTallas(); montaSticky(); montaVistas(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arranca);
  } else { arranca(); }
})();
